import clsx from 'clsx';
import React from 'react';

import s from './EllipsisMiddle.module.less';

interface Props {
  suffixCount: number;
  children: string;
  className?: string;
}

export const EllipsisMiddle = ({ suffixCount, children: _children, className, ...rest }: Props) => {
  const text = String(_children ?? '');

  if (!text) {
    return null;
  }

  const start = (text || '').slice(0, text.length - suffixCount).trim();
  const suffix = (text || '').slice(-suffixCount).trim();

  return (
    <span className={clsx(s.root, className)} title={text} {...rest}>
      <span className={s.start}>{start}</span>
      <span className={s.suffix}>{suffix}</span>
    </span>
  );
};
